import React, { useState, useEffect, useContext } from 'react'
import EquipmentService from '../../../../../services/api/equipment.service'
import EquipmentForm from '../equipment-form/EquipmentForm'
import APIResponse from '../../../../templates/components/APIResponse'
import DimLoader from '../../../../templates/components/DimLoader'
import { store } from '../../../../../context/StateProvider'
import ModalBox from '../../../../templates/components/ModalBox'

const EditEquipment = (props) => {
    const { id, inputChange } = props;
    const [formData, setFormData] = useState({})
    const [messages, setMessages] = useState({})
    const [isLoaded_form, setIsLoaded_form] = useState(false)
    const [apiResponse, setApiResponse] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const [ignoreInActivePracticeServiceType, setIgnoreInActivePracticeServiceType] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [submitData, setSubmitData] = useState({})
    const globalStateAndDispatch = useContext(store)
    const dispatch = globalStateAndDispatch.dispatch
    const onSuccess = (message) => {
        dispatch({
            type: "setLocationEquipment",
            payload: null
        });
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.onClose) {
            props.onClose()
        }
    }
    const onError = (error, showConfirmationModal) => {
        if (showConfirmationModal) {
            // Check if API returns array or string
            const message =
                Array.isArray(error) && error.length > 0
                    ? error[0]
                    : typeof error === "string"
                        ? error
                        : "The selected service(s) is inactive."; // fallback

            setErrorMessage(message);
            setConfirmModal(true);
        }
    }

    useEffect(() => {
        if (ignoreInActivePracticeServiceType) {
            setConfirmModal(false)
            submitHandler(submitData);
        }
    }, [ignoreInActivePracticeServiceType])

    useEffect(() => {
        setIsLoaded_form(false)
        EquipmentService.getEquipmentById(id)
            .then(res => {
                setFormData(res.data)
                setIsLoaded_form(true)
            })
            .catch(err => { setIsLoaded_form(true) })
    }, [])

    const submitHandler = (data) => {
        setIsLoader(true)
        setSubmitData(data)
        let requestData = {
            equipmentId: data.equipmentId,
            description: data.description,
            practiceLocationId: data.practiceLocationId,
            equipmentTypeId: data.equipmentTypeId,
            practiceServiceTypeIds: data.practiceServiceTypeIds,
            practiceLocationRoomId: data.practiceLocationRoomId
        }
        if (!requestData?.practiceLocationRoomId || requestData?.practiceLocationRoomId === "") {
            delete requestData.practiceLocationRoomId
        }
        if (!requestData?.practiceServiceTypeIds || requestData?.practiceServiceTypeIds === "") {
            delete requestData.practiceServiceTypeIds
        }
        if (ignoreInActivePracticeServiceType) {
            requestData.ignoreInActivePracticeServiceType = ignoreInActivePracticeServiceType
        }
        EquipmentService.editEquipment(requestData)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            }).finally(() => {
                setIgnoreInActivePracticeServiceType(false);
                setIsLoader(false)
            });
    }

    return (
        <>
            {isLoader && <DimLoader />}
            {isLoaded_form && <EquipmentForm isEdit submitHandler={submitHandler} initialData={formData} messages={messages} inputChange={inputChange} submitLabel="Update" onClose={() => props.onClose()} />}
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} onError={onError} toastOnSuccess={true} />
            <ModalBox open={confirmModal} onClose={() => setConfirmModal(false)} title="Confirm">
                <div className="row d-flex justify-content-between align-items-center">
                    <div className="col">
                        <p>{errorMessage} Override and save equipment?</p>
                    </div>
                    <div className="col-auto">
                        <button
                            className="btn btn-primary"
                            onClick={(e) => {
                                e.preventDefault();
                                setIgnoreInActivePracticeServiceType(true);
                            }}
                        >
                            OK
                        </button>
                        <button
                            className="btn btn-secondary ms-3"
                            onClick={(e) => {
                                e.preventDefault();
                                setConfirmModal(false);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </ModalBox>
        </>
    )
}

export default EditEquipment